import { render, staticRenderFns } from "./movement-detail.vue?vue&type=template&id=2172dfa4&"
import script from "./movement-detail.vue?vue&type=script&lang=js&"
export * from "./movement-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports